<template>
<div>
  <el-dialog
    :visible.sync="visible"
    append-to-body
    :close-on-press-escape="false"
    show-close
    class="login-dialog-container"
    :close-on-click-modal="false"
    top="8vh"
    custom-class="login-wrap"
    :class="chatAvatar ? '' : 'has-sider'"
  > 
    <div class="login-content">
      <ThirdPary
        :isBanner="isBanner"
        :isHome="isHome"
        :isClickOrder="isClickOrder"
        :isCommonLogin="true"
        :chatAvatar="chatAvatar"
        :inviterUuid="inviterUuid"
        @ThirdparyLoginSuccess="beforeSuccess"
        @closeLogin="visible=false"
      />
      <p class="or">或</p>
      <p class="phone-login" @click="phoneLogin">使用手機號登入</p>
      <div class="login-protocol">
        <p>登入即代表您同意<span @click="jumpPage('/privacy')">nicee服務協議與隱私權條款</span></p>
      </div>
    </div>
  </el-dialog>
  <phoneLogin
    :redirect="redirect"
    :phoneLoginDialog="phoneLoginDialog"
    :allowThirdParyLogin="true"
    :inviterUuid="inviterUuid"
    @closePhoneLogin="closePhoneLogin"
    @successLogin="success($event)"
    @thirdParyLogin="thirdParyLogin()"
  />
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getSmsCode } from '@/api'
import mobileAreaList from '@/utils/areas-code'
import ThirdPary from './components/thirdpary-new.vue'
import Clickoutside from "@/utils/clickoutside"
import phoneLogin from './components/phone-login.vue'

export default {
  name: 'Login',
  directives: {
    clickoutside: Clickoutside
  },
  components: {
    ThirdPary,
    phoneLogin
  },
  data() {
    return {
      isKeepLoginStatus: true,
      isShowMobileAreaSelectList: false,
      mobileAreaList: mobileAreaList,
      currentSelectPrefix: {
        code: 886
      },
      isSendingSmsCode: false,
      isLogining: false,
      sendCodeTimer: 0,
      visible: false,
      chatAvatar: '',
      isHome: false,
      brandSocialTest: '',
      brandGamingTest: '',
      isSix: false,
      isBanner: false,
      loginObj: {
        phoneNumber: '',
        verifyCode: '',
        keyUuid: null,
        isHome: false,
        brandSocialTest: '',
        brandGamingTest: '',
        isBanner: false,
      },
      tencentCaptchaInstance: null,
      timer:null,
      isClickOrder: false,
      phoneLoginDialog: false,
      redirect:'',
      inviterUuid:''//註冊時的邀請人uuid
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    isMobile() {
      return window.innerWidth < 600;
    }
  },
  methods: {
    thirdParyLogin() {
      this.phoneLoginDialog = false;
      this.$nextTick(()=>{
      this.visible = true;
      })
    },
    closePhoneLogin(res){
      this.phoneLoginDialog = res
      this.visible = res
    },
    phoneLogin() {
      this.visible = false
      this.phoneLoginDialog = true
    },
    jumpPage(page) {
      this.$util.openWindow(page)
    },
    /**
     * @description 是否记住登录状态
     */
    changeIsKeepLoginStatus() {
      this.isKeepLoginStatus = !this.isKeepLoginStatus
    },
    toggleMobileAreaSelectList() {
      this.isShowMobileAreaSelectList = !this.isShowMobileAreaSelectList
    },
    closeMobileAreaSelectList() {
      this.$nextTick(() => {
        if (this.isShowMobileAreaSelectList) {
          this.isShowMobileAreaSelectList = false
        }
      })
    },
    selectMobileArea(code) {
      this.currentSelectPrefix.code = code
      this.closeMobileAreaSelectList()
    },
    /**
     * @description 獲取驗證碼
     */
    getValidateCode() {
      const { phoneNumber } = this.loginObj

      if (!phoneNumber) return this.$message.error('請輸入手機號碼')
      
      if (!this.tencentCaptchaInstance) {
        this.tencentCaptchaInstance = new window.TencentCaptcha(document.querySelector('#verification-code'), process.env.VUE_APP_VERIFICATION_APPID, resp => {
          if (resp.ret === 0) {
            this.isSendingSmsCode = true
            const { phoneNumber } = this.loginObj
            const { code } = this.currentSelectPrefix

            getSmsCode({
              phoneNumber: code + phoneNumber,
              ticket: resp.ticket,
              rand: resp.randstr
            }).then(({ data }) => {
              if (data) {
                this.loginObj.keyUuid = data
                this.setSmsCodeInterval(30)
              }

              this.isSendingSmsCode = false
            }).catch(err => {
              this.isSendingSmsCode = false
              if (err.msg) {
                if (err.msg === 'InvalidParameterValue.IncorrectPhoneNumber') {
                  this.$message.error('手機號格式錯誤')
                  return
                }
                this.$message.error(err.msg)
              }
            })
          }
        })
      }

      this.tencentCaptchaInstance.show()
    },
    /**
     * @description 設置發送驗證碼倒計時
     */
    setSmsCodeInterval(count) {
      this.sendCodeTimer = count
      clearTimeout(this.timer)
      if (count > 0) {
        this.timer = setTimeout(this.setSmsCodeInterval.bind(this, --count), 1000)
      }
    },
    /**
     * @description 校驗輸入輸入內容
     */
    validateInputMsg() {
      const { phoneNumber, verifyCode, keyUuid } = this.loginObj
      const { code } = this.currentSelectPrefix
      if (!phoneNumber) {
        this.$message.error('請輸入正確的手機號碼')
        return false
      }
      if (verifyCode.length !== 4) {
        this.$message.error('認證碼錯誤')
        return false
      }
      let inviterUnique = window.localStorage.getItem('STORAGE_INVITER_UUID') || null
      if (!inviterUnique) {
        const str = sessionStorage.getItem('INVITE_UNIQUE')
        str && (inviterUnique = JSON.parse(str).inviterUnique)
      }
      return {
        phoneNumber: code + phoneNumber,
        verifyCode,
        keyUuid,
        isSaveToken: this.isKeepLoginStatus,
        isHome: this.isHome,
        brandSocialTest: this.brandSocialTest,
        brandGamingTest: this.brandGamingTest,
        isBanner: this.isBanner,
        inviterUnique,
      }
    },
    /**
     * @description 登陸
     */
    async login() {
      if(this.isHome) {
        // window.gtag('Login', 'FreeGame', 'Profile')
      }
      if(this.isBanner) {
        // window.gtag('Login', 'FreeGame', 'Banner')
      }
      const params = this.validateInputMsg()
      if (params && !this.isLogining) {
        this.isLogining = true
        // window.gtag('Click', 'Login', 'Dialog')
        if (this.isSix) {
          // window.gtag('Login', 'JoinWall', 'Max_5')
        }
        try {
          await this.$store.dispatch('app/login', params)
          this.isLogining = false
          this.visible = false
          this.isEmpty()
          this.beforeSuccess()
        } catch(e) {
          this.isLogining = false
        }
      }
    },
    beforeSuccess(params) {
      const { userInfo } = this
      let isLogin = false
      if (params && params.isThirdpary && params.isLogin) {
        isLogin = true
      }
      if (!params) {
        if (userInfo.isNewRegistration) {
          if(userInfo.phoneNumber.substring(0, 3) !== '886') {
            this.$message({
              message: '很遺憾，目前新人優惠券只支持台灣地區的手機號'
            })
          } else if (!userInfo.hasRedBag) {
            this.$message({
              message: '每個用戶註冊後只有一次使用新人優惠券機會喔'
            })
          }
        } else {
          isLogin = true
        }
      }
      this.success({ isLogin })
    },
    isEmpty(){
      this.loginObj.verifyCode = ''
      this.setSmsCodeInterval(0)
    }
  }
}
</script>

<style lang="scss" scoped>
  .button-hover:hover {
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), linear-gradient(167.68deg, #FF4417 2.04%, #FB006E 60.91%) !important;
  }
  
  @media screen and (min-width: 600px) {
    .login-dialog-container {
      & /deep/ .el-dialog{
        width: 386px;
        border-radius: 8px;
      }
      & /deep/ .el-dialog__header {
        padding: 0;
      }

      & /deep/ .el-dialog__body {
        padding-bottom: 30px;
        padding-top: 64px;
        border-radius: 8px;
        background: white;
      }
    }
    .or {
      font-style: normal;
      font-weight: normal;
      font-size: 13px;
      line-height: 75px;
      height: 75px;
      text-align: center;
      color: #CCCCCC;
    }
    .phone-login {
      height: 48px;
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      width: 280px;
      line-height: 48px;
      text-align: center;
      color: #333333;
      cursor: pointer;
      background: #FFFFFF;
      box-shadow: 0px 0.8px 4px rgba(0, 0, 0, 0.1);
      border-radius: 30px;
      margin: 0 auto 30px;
    }
    .login-protocol {
      font-size: 13px;
      line-height: 18px;
      color: #666;
      text-align: center;

      span {
        cursor: pointer;
        text-decoration: underline;
        color: $color-gray-1;
      }
    }

    // .has-sider {
    //   & /deep/ .el-dialog{
    //     right: 193px;
    //     position: relative;
    //     border-top-left-radius: 8px;
    //     border-bottom-left-radius: 8px;
    //     border-bottom-right-radius: 0px;
    //     border-top-right-radius: 0px;
    //   }
    // }
    .login-sider {
      position: absolute;
      // width: 386px;
      top: 0px;
      left: 100%;
      height: 100%;
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;
      border-bottom-right-radius: 8px;
      border-top-right-radius: 8px;
    }
    .login-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      .read-privacy {
        display: flex;
        p:first-child {
          font-style: normal;
          font-weight: normal;
          font-size: 12px;
          line-height: 17px;
          color: #666666;
        }
        p:last-child {
          font-style: normal;
          font-weight: normal;
          font-size: 12px;
          line-height: 17px;
          color: #FA006E;
          cursor: pointer;
        }
      }
    }
  }
  
  @media screen and (max-width: 599px) {
    .dialog-msg {
      font-size: 15px;
      line-height: 21px;
    }
    .login-dialog-container {
      & /deep/ .el-dialog{
        width: 343px !important;
        max-width: 91vw;
        border-radius: 8px;
      }
      & /deep/ .el-dialog__header {
        padding: 0;
      }

      & /deep/ .el-dialog__body {
        padding-bottom: 30px;
        box-sizing: border-box;
      }
    }
    .login-sider {
      display: none;
    }
    .or {
      font-style: normal;
      font-weight: normal;
      font-size: 13px;
      line-height: 75px;
      height: 75px;
      text-align: center;
      color: #CCCCCC;
    }
    .phone-login {
      height: 48px;
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      width: 280px;
      line-height: 48px;
      text-align: center;
      color: #333333;
      cursor: pointer;
      background: #FFFFFF;
      box-shadow: 0px 0.8px 4px rgba(0, 0, 0, 0.1);
      border-radius: 30px;
      margin: 0 auto 35px;
    }
    .login-protocol {
      font-size: 13px;
      line-height: 18px;
      color: #666;
      text-align: center;

      span {
        cursor: pointer;
        text-decoration: underline;
        color: $color-gray-1;
      }
    }

  }
</style>
